import ButtonBase from '@ixigo/iui/ButtonBase';
import Typography from '@ixigo/iui/Typography';
import {
	AdvanceReceipt,
	ETicket,
	Invoice,
	ModifyBooking,
} from '@repo/shared/icons';
import cn from '@repo/shared/utils/cn';
import { useEffect } from 'react';
import { downloadPdfDocument, prefetchPwaUtils } from '@/lib/pwa/pdf';

interface ActionButtonsProps {
	actions: {
		eticketUrl?: string;
		invoiceUrl?: string;
		advanceReceiptUrl?: string;
		showModifyBooking?: boolean;
	};
	className?: string;
}

export function ActionButtons({ actions, className = '' }: ActionButtonsProps) {
	useEffect(() => {
		prefetchPwaUtils();
	}, []);

	const handleModifyBooking = () => {
		document.getElementById('modify-booking')?.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
	};

	const actionItems: ActionItemProps[] = [];

	if (actions.eticketUrl) {
		const eticketUrl = actions.eticketUrl;
		actionItems.push({
			icon: <ETicket width={40} height={40} />,
			label: (
				<span>
					Download <br /> E-Ticket
				</span>
			),
			onClick: () => downloadPdfDocument(eticketUrl),
		});
	}
	if (actions.advanceReceiptUrl) {
		const advanceReceiptUrl = actions.advanceReceiptUrl;
		actionItems.push({
			icon: <AdvanceReceipt width={40} height={40} />,
			label: (
				<span>
					Download <br /> Receipt
				</span>
			),
			onClick: () => downloadPdfDocument(advanceReceiptUrl),
		});
	}

	if (actions.invoiceUrl) {
		const invoiceUrl = actions.invoiceUrl;
		actionItems.push({
			icon: <Invoice width={40} height={40} />,
			label: (
				<span>
					Download <br /> Invoice
				</span>
			),
			onClick: () => downloadPdfDocument(invoiceUrl),
		});
	}

	if (actions.showModifyBooking) {
		actionItems.push({
			icon: <ModifyBooking width={40} height={40} />,
			label: (
				<span>
					Modify <br /> Booking
				</span>
			),
			onClick: handleModifyBooking,
		});
	}

	return (
		<div className={cn('flex gap-20 justify-between items-center', className)}>
			{actionItems.map((item, index) => (
				<ActionItem key={index} {...item} />
			))}
		</div>
	);
}

interface ActionItemProps {
	icon: React.ReactNode;
	label: React.ReactNode;
	onClick: () => void;
}

const ActionItem = ({ icon, label, onClick }: ActionItemProps) => {
	return (
		<ButtonBase
			onClick={onClick}
			className="flex flex-col items-center justify-center gap-2 mx-auto"
			disableRipple
		>
			{icon}
			<Typography variant="body-xs">{label}</Typography>
		</ButtonBase>
	);
};
